import { render, staticRenderFns } from "./single-view.vue?vue&type=template&id=1ff631de&scoped=true&"
import script from "./single-view.vue?vue&type=script&lang=js&"
export * from "./single-view.vue?vue&type=script&lang=js&"
import style0 from "./single-view.vue?vue&type=style&index=0&id=1ff631de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff631de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
